import React from 'react';
import { useIntl } from 'react-intl';
import { ApiFilterOperation, Evidence } from '@eas/common-web';
import { EsFileState } from '@enums';
import { useColumns } from '../closed/inf-file-closed-columns';
import { useInfFiles } from '../inf-files';

export const INF_FILES_REGISTRY_IDENTIFIER = 'INF_FILES_REGISTRY';
export const INF_FILES_REGISTRY_VERSION = 3;

export function InfFilesRegistry() {
  const intl = useIntl();

  const columns = useColumns();

  const { evidenceBag } = useInfFiles({
    evidenceProps: {
      identifier: INF_FILES_REGISTRY_IDENTIFIER,
      version: INF_FILES_REGISTRY_VERSION,
      tableProps: {
        columns,
        defaultPreFilters: [
          {
            field: 'state.id',
            operation: ApiFilterOperation.EQ,
            value: EsFileState.REGISTRY,
          },
        ],
        tableName: intl.formatMessage({
          id: 'ES__INF_FILES_REGISTRY__TABLE__TITLE',
          defaultMessage: 'Spisy INF - Spisovna',
        }),
      },
      detailProps: {
        toolbarProps: {
          showBtn: (btn) => !['NEW'].includes(btn),
          disableBtn: (btn) => !['REFRESH', 'SHARE'].includes(btn),
        },
      },
    },
  });

  return <Evidence {...evidenceBag} />;
}
